/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../../components/layout/Layout";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { reset, updateUser } from "../../../redux/auth/authSlice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import QRCode from "react-qr-code";
import Loader from "components/Loader";
import { DiscoverInvozio } from "../DiscoverInvozio";
import ReactivateModal from "./reactivateModal";
import { LOCALES } from "common/constants";

const Login = () => {
  const [bankDetails, setBankDetails] = useState([]);
  const [bankAuth, setBankAuth] = useState([]);
  const [show, setShow] = useState(false);
  const [loginWithSSN, setLoginWithSSN] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const data = new URLSearchParams(location.search);

  const getParamsEmail = data.get("email");
  const [getEmail, setgetEmail] = useState(null);
  const [toggleReactivate, settoggleReactivate] = useState(false);
  const [inactiveAccount, setInactiveAccount] = useState(false);

  const [QRState, setQRState] = useState({
    isLoading: false,
    qrToken: false,
    customMessage:
      "Please initiate the BankID application on your device, proceed to enter your security code, and select the Identify option",
  });

  const [searchParams] = useSearchParams();
  const getQueryParams = (query) => {
    return new URLSearchParams(query);
  };
  
  const queryParams = getQueryParams(location.search);
  const invoiceNumber = queryParams.get("invoiceNumber");
  const isAuthorize = queryParams.get("isAuthorize") == "true";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { isError, message } = useSelector((state) => state.auth);
  let language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    if (searchParams.get("message")) {
      const splitMessage = searchParams.get("message").split("?")[0];
      if (splitMessage === "account_deactivated") {
        settoggleReactivate(true);
      }
      if (splitMessage === "inactive_account") {
        settoggleReactivate(true);
        setInactiveAccount(true);
      }
      // toast.error(t(splitMessage));
    }
    setShow(false);
    // setSearchParams({});
  }, [searchParams, t]);

  const loginMobileID = async () => {
    setQRState((prevState) => ({ ...prevState, isLoading: true }));
    try {
      const res = await axios.get(`auth`);
      if (res?.status === 200) {
        setBankAuth(res.data.response);
        setQRState((prevState) => ({ ...prevState, isLoading: false }));
      }
    } catch (error) {
      setQRState((prevState) => ({
        ...prevState,
        isLoading: false,
        customMessage: error?.response?.data?.message,
      }));
      if (error?.response?.data) {
        if (
          window.location.pathname === "/logga-in" ||
          window.location.pathname === "/login"
        ) {
          loginMobileID();
        }
      }
    }
  };

  useEffect(() => {
    if (loginWithSSN) {
      if (
        window.location.pathname === "/logga-in" ||
        window.location.pathname === "/login"
      ) {
        loginMobileID();
      }
    }
  }, [loginWithSSN]);

  useEffect(() => {
    return () => dispatch(reset());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      setShow(false);
      toast.error(t(message));
      dispatch(reset());
    }
  }, [isError, message, dispatch, t]);

  const getBankDetails = async () => {
    try {
      const res = await axios.get(`auth`);
      if (res?.status === 200) {
        setBankDetails(res?.data?.response);
      }
    } catch (err) {
      // toast.error(t(err?.response?.data?.message));
    }
  };

  useEffect(() => {
    getBankDetails();
  }, []);

  const appLogin = () => {
    const url1 = `${import.meta.env.VITE_API_URL}/auth/collect-response/${bankDetails?.id}?lang=${language}`;
    let encoded = encodeURIComponent(url1);
    const url = `https://app.bankid.com/?autostarttoken=${bankDetails?.autoStartToken}&redirect=${encoded}`;
    // loginMobileID();
    window.open(url, "_blank");
  };

  const getUserToken = async () => {
    try {
      const result = await axios.get(
        `/auth/collect-response/qr-code/${bankAuth?.id}`
      );

      if (result?.status === 200) {
        if (!result?.data?.response?.token) {
          if (result?.data?.message === "SESSION_TIMEOUT") {
            setQRState((prevState) => ({
              ...prevState,
              customMessage:
                "Your session has expired due to inactivity, Please try again",
              qrToken: null,
            }));
          } else {
            setQRState((prevState) => ({
              ...prevState,
              customMessage: result?.data?.message,
              qrToken: null,
            }));
          }
        } else {
          setQRState((prevState) => ({
            ...prevState,
            qrToken: true,
          }));

          dispatch(updateUser(result?.data?.response?.userData));
          localStorage.setItem("user", JSON.stringify(result?.data?.response));
          const logged = result?.data?.response?.isLoginWithBankId;
          if (logged) {
            document.cookie = `logged=1; path=/`;
          }
          navigate(
            language === LOCALES.EN_US
              ? `/dashboard/activities?lang=${LOCALES.EN_US}`
              : `/instrumentbrada/aktiviteter?lang=${LOCALES.SV_SE}`
          );
          toast.success(t("Logged in successfully"));
        }
      }

      if (result?.data?.message === "account_deactivated" || result?.data?.message === "inactive_account") {
        setgetEmail(result?.data?.response?.userData);
        settoggleReactivate(true);
        if (result?.data?.message === "inactive_account") {
          setInactiveAccount(true);
        }
      }
    } catch (err) {
      setQRState((prevState) => ({
        ...prevState,
        customMessage: err?.response?.data?.message,
        qrToken: null,
      }));
      if (
        err?.response?.data?.message ===
        "There is issue from bank side. Please try after some time"
      ) {
        getUserToken();
      }
    }
  };

  useEffect(() => {
    if (bankAuth?.id) {
      getUserToken();
    }
  }, [bankAuth]);

  return (
    <Layout
      className="d-flex login new_sign_up new_margin_header"
      hidefooter
      headerColor="secondary"
    >
      {loading && <Loader />}

      <div className="logn_pge_dsgn mobile">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <DiscoverInvozio />
            </div>
            <div className="col-md-6">
              <div className="bg-light mt-0">
                <form
                // onSubmit={handleSubmit(onSubmit)}
                >
                  <h1 className="text-center text-dark ">{t("Sign in")}</h1>

                  {loginWithSSN && (
                    <>
                      <div className="text-center">
                        {QRState?.isLoading ? (
                          <>
                            <p>
                              {t(
                                "Please wait while your QR code is being generated"
                              )}
                            </p>
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            ></div>
                          </>
                        ) : (
                          bankAuth?.id &&
                          QRState?.qrToken !== null && (
                            <QRCode value={bankAuth?.qrCode} />
                          )
                        )}
                      </div>
                    </>
                  )}

                  {Object.keys(errors).length > 0 && (
                    <div className="text-center w-100">
                      <p className="text-danger">
                        {errors[Object.keys(errors)[0]].message}
                      </p>
                    </div>
                  )}

                  {loginWithSSN && !QRState?.isLoading && (
                    <p className="mb-4" style={{ textAlign: "center" }}>
                      {t(
                        (QRState?.customMessage === "account_deactivated" || QRState?.customMessage === "inactive_account")
                          ? "Account Deactivated"
                          : QRState?.customMessage
                      )}
                    </p>
                  )}

                  {loginWithSSN &&
                    QRState?.qrToken === null &&
                    !QRState?.isLoading && (
                      <Button
                        className="text-light filled new_theme_btn"
                        size="lg"
                        onClick={() => {
                          loginMobileID();
                          setQRState((prevState) => ({
                            ...prevState,
                            customMessage:
                              "Please initiate the BankID application on your device, proceed to enter your security code, and select the Identify option",
                            qrToken: false,
                          }));
                        }}
                      >
                        {t("Reload QR")}
                      </Button>
                    )}

                  {!loginWithSSN && (
                    <div className="d-flex flex-column justify-content-center mb-4 flex-sm-columns">
                      <Button
                        onClick={() => setLoginWithSSN(true)}
                        className=" text-light filled new_theme_btn"
                        size="lg"
                      >
                        {t("Mobile BankID On Another Device")}
                      </Button>
                      {bankDetails?.id ? (
                        <Button
                          onClick={() => appLogin()}
                          className="mt-4 text-light filled new_theme_btn"
                          size="lg"
                        >
                          {t("Mobile BankID On Same Device")}
                        </Button>
                      ) : (
                        <Button
                          className="mt-4 text-light filled new_theme_btn"
                          size="lg"
                          disabled={!bankDetails?.id}
                        >
                          {t("Loading...")}
                        </Button>
                      )}
                    </div>
                  )}
                  {loginWithSSN && (
                    <Link
                      style={{ textDecoration: "underline" }}
                      className="d-block mt-2 mb-3 text-right"
                      onClick={(e) => {
                        e.preventDefault();
                        setLoginWithSSN(false);
                      }}
                    >
                      {t("Cancel Login")}
                    </Link>
                  )}
                  <div className="seprator my-1">
                    <p className="text-center">{t("OR")}</p>
                  </div>
                  <div className="btns d-flex align-items-center justify-content-center mb-3">
                    <Button
                      className="mt-4 text-light filled new_theme_btn "
                      size="lg"
                      onClick={() =>{
                        if (invoiceNumber) {
                          navigate(
                            language === LOCALES.EN_US
                              ? `/emaillogin?lang=${LOCALES.EN_US}&invoiceNumber=${invoiceNumber}&isAuthorizedForReminder=true`
                              : `/e-postinloggning?lang=${LOCALES.SV_SE}&invoiceNumber=${invoiceNumber}&isAuthorizedForReminder=true`
                          );
                        } else {
                          navigate(
                            language === LOCALES.EN_US ? `/emaillogin?lang=${LOCALES.EN_US}` : `/e-postinloggning?lang=${LOCALES.SV_SE}`
                          );
                        }
                      }
                       
                      }
                    >
                      {t("Email and password")}
                    </Button>
                    {/* <Button
                          className="ml-4"
                          variant="outline-primary bg-light"
                          size="lg"
                          onClick={() => navigate('/idlogin')}
                        >
                          Bank Id
                        </Button> */}
                  </div>
                </form>
                {show && (
                  <Modal
                    show={true}
                    centered
                    onHide={() => setShow(false)}
                    size="lg"
                  >
                    <Modal.Header>
                      <Modal.Title>
                        {t("You Are login with SSN-No")}
                      </Modal.Title>
                      <AiOutlineClose
                        className="ml-auto cursor-pointer"
                        size={24}
                        onClick={() => setShow(false)}
                      />
                    </Modal.Header>
                    <Modal.Body>
                      {t(
                        "Please Open Your Mobile-Bank-Id-App And Continue The Process"
                      )}
                    </Modal.Body>
                    {/* <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShow(false)}>
                          Cancel
                        </Button>
                      </Modal.Footer> */}
                  </Modal>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReactivateModal
        qrCodeEmail={getEmail}
        toggleReactivate={toggleReactivate}
        settoggleReactivate={settoggleReactivate}
        getParamsEmail={getParamsEmail}
        setInactiveAccount={setInactiveAccount}
        inactiveAccount={inactiveAccount}
      />
    </Layout>
  );
};

export default Login;
